import React from 'react';
import { Map, Globe, Info } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';

type HeaderProps = {
  totalVisited: number;
  totalExhibits: number;
  onShowStats: () => void;
  onShowCredits?: () => void;
};

const Header: React.FC<HeaderProps> = ({ totalVisited, totalExhibits, onShowStats, onShowCredits }) => {
  const { t, currentLocale, setLocale } = useLocale();
  
  const toggleLanguage = () => {
    const newLocale = currentLocale === 'en' ? 'ro' : 'en';
    setLocale(newLocale);
  };
  
  return (
    <div className="backdrop-blur-sm border-b px-4 py-4" style={{ backgroundColor: 'var(--color-primary)', borderColor: 'var(--border-primary)' }}>
      <div className="flex items-center justify-between">
        <div>
          <button
            onClick={onShowCredits}
            className="p-2 rounded-lg transition-colors uppercase hover:opacity-80"
            style={{ backgroundColor: 'var(--color-capsule)' }}
            title={t('header.credits')}
          >
            <div className="flex items-center gap-1">
              <Info className="w-4 h-4" style={{ color: 'var(--color-capsule-text)' }} />
              <span className="text-base font-medium" style={{ color: 'var(--color-capsule-text)' }}>
                {t('header.credits')}
              </span>
            </div>
          </button>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={toggleLanguage}
            className="p-2 rounded-lg transition-colors uppercase"
            style={{ backgroundColor: 'var(--color-capsule)' }}
            title={`Switch to ${currentLocale === 'en' ? 'Romanian' : 'English'}`}
          >
            <div className="flex items-center gap-1">
              <Globe className="w-4 h-4" style={{ color: 'var(--color-capsule-text)' }} />
              <span className="text-base font-medium" style={{ color: 'var(--color-capsule-text)' }}>
                {currentLocale.toUpperCase()}
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header; 